import BaseStateSprite from "../../../../engines/components/state/BaseStateSprite";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import utilsView from "../../../../engines/libs/utilsView";
import { GAME_MODE } from "../../../../engines/managers/gameContent/gameMode_json";
import { UIKind } from "../../../define/UIKind";
import { AccountItem } from "../../manager/DefineInterface";
import NormalGameManager from "../../manager/NormalGameManager";
import backpackOpenBase from "../backpackOpenBase";
import loanSuccessPage from "./loanSuccessPage";

const {ccclass, property} = cc._decorator;

@ccclass
export default class loanPage extends backpackOpenBase {

    @property({type:cc.Label,tooltip:"描述文本"})
    lbExplain:cc.Label = null;

    @property({type:[cc.Label],tooltip:"剩余次数文本"})
    lbResidue:cc.Label[] = [];

    @property({type:cc.Node,tooltip:"第一个按钮"})
    oneBtn:cc.Node = null;

    @property({type:cc.Node,tooltip:"第二个按钮"})
    twoBtn:cc.Node = null;

    @property([cc.Node])
    nodeLoanBtnList: cc.Node[] = [];

    noMoneyChat:string = "您的余额不足以偿还今天应还款，您可以选择重新开始或者接受我的贷款在这里继续生活下去";
    backpackChat:string = "少侠，听说你缺钱用了，需不需要从我这里贷款，最低利率只收5%，考虑一下";

    completeFun?:(isTrue:boolean)=>void

    openType:string = null;

    onBackPackOpenPrefab(...arg: any[]): void {
        this.bindType("onBackpack");
    }

    bindType(type:string,complete?:(isTrue:boolean)=>void){
        this.openType = type;
        this.completeFun = complete;
    }

    protected start(): void {
        this.loadPage();
    }

    //加载页面
    loadPage(){
        let label:cc.Label = this.oneBtn.getChildByName("label").getComponent(cc.Label);
        let chat:string = this.noMoneyChat;
        switch(this.openType){
            case "onBackpack":{
                label.string = "暂不考虑";
                chat = this.backpackChat;
                break;
            }
            case "lose":{
                label.string = "重新开始";
                chat = this.noMoneyChat;
                break;
            }
            case "noMoney":{
                label.string = "暂不考虑";
                // chat = this.noMoneyChat;
                chat = this.backpackChat;
                break;
            }
        }
        this.loadExplain(chat);
        this.updateResidueCount();
    }

    async loadExplain(chat:string){
        for(let i=0;i<chat.length;i++){
            let c = chat[i];
            this.lbExplain.string += c;
            await new Promise<void>(resolve=>{
                this.scheduleOnce(resolve,0.05);
            });
        }
    }

    //更新剩余次数
    updateResidueCount(){ 
        this.lbResidue.forEach((v)=> {
            v.string = `${NormalGameManager._instance.getGameData().loanCount || 0}/3`;
        });

        if( NormalGameManager._instance.getGameData().loanCount && NormalGameManager._instance.getGameData().loanCount >= 3 ) {
           this.nodeLoanBtnList.forEach((v)=> {
                let state = v.getComponent(BaseStateSprite);
                let sprGold = v.getChildByName('layout').getChildByName('spr_coin_copper').getComponent(cc.Sprite);
                utilsView.setSpriteGray(sprGold);
                state.setFill(true);
           });
        }
    }

    //点击第一个
    onBtnOne(){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.completeFun && this.completeFun(false);
        switch(this.openType){
            case "onBackpack":
            case "noMoney":{
                this.closeThis();
                break;
            }
            case "lose":{
                this.reStartGame();
                break;
            }
        }
    }

    closeThis(){
        O1HD?.emit("normalMode.onBackNormal", UIKind.UILayerTag.LOAN_PAGE);
        this.node.destroy();
        this.node.removeFromParent();
    }

    reStartGame(){
        NormalGameManager._instance.spliceOneNodeStrs(UIKind.UILayerTag.LOAN_PAGE);
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // this.gameLayer.gameManager.pauseTimer();
        NormalGameManager._instance.setGameData({gameFail : 0} , false );
        //重新开始
        NormalGameManager._instance.resetManager();
        O1HD.getManagers().gameMgr.selectMode( GAME_MODE.NORMAL ).then();
    }

    //点击第二个
    onBtnTwo(event: cc.Event.EventTouch, data){
        O1HD.getManagers().soundMgr.playSound("anNiu");
        // 判断 贷款次数
        if( NormalGameManager._instance.getGameData().loanCount && NormalGameManager._instance.getGameData().loanCount >= 3 ) {
            O1HD.getModules().uiControlModule.showMessageBox("一场游戏内，最多只可贷款三次" );
            return;
        }
        //看广告
        utilsModel.loadAndShowVideoAdTrans(()=>{
            // this.gameLayer.gameManager.alive();
            let idx = Number(data);
            let loanList = [
                [50000, 52500, 10]
                , [6000000, 6300000, 15]
                , [20000000, 21000000, 20]
            ]
            let retL = loanList[idx];
            this.loanSuccess(retL[0], retL[1], retL[2]);
        },()=>{

        },null,"看广告贷款")
    }

    loanSuccess(
        recvLoan: number
        , totalFee: number
        , totalDay: number
    ) {
        O1HD.getServices().userSrv.setCoins( recvLoan, true );
        // 添加贷款日志记录
        let everyDayPay = Math.floor(totalFee/ totalDay);
        let rate = ((totalFee-recvLoan) / recvLoan * 100).toFixed(1);
        let accountItem : AccountItem[] = [
            {
                uniqueId:`${NormalGameManager._instance.getGameData().userAccountInfo.length+1}`,
                title : "贷款还款",
                desc : "成功贷款@！日利率@ \n限期@还清，每日还款@",
                paramsArray:[recvLoan + "元", rate+"%", totalDay + "日", "" + everyDayPay],
                totalFee : totalFee,
                needPayDays : totalDay,
                hasPayDays : 0,
                everyDayPay: everyDayPay,
            },
        ];
        // this.gameLayer.gameManager.resumeTimer();
        NormalGameManager._instance.setGameData({gameFail : 0} , false );
        NormalGameManager._instance.setGameData( { userAccountInfo:accountItem },true );
        NormalGameManager._instance.setGameData( { userAccountInfoNewMsg : 1 },false );
        let loanCount = NormalGameManager._instance.getGameData().loanCount ? NormalGameManager._instance.getGameData().loanCount + 1 : 1;
        NormalGameManager._instance.setGameData( { loanCount : loanCount },false );
        O1HD.emit("normalMode.loanSuccess",accountItem[0].desc , accountItem[0].paramsArray );
        this.updateResidueCount();
        this.completeFun && this.completeFun(true);
        this.closeThis();
    }

    update(dt: number): void {
        NormalGameManager._instance.pauseTimer();
    }

    onDisable(): void {
        NormalGameManager._instance.resumeTimer();
    }
    
}
